{
  "fr": {
    "bookmark": {
      "hints": {
        "body": "Découvrez maintenant des matériels pédagogiques gratuits dans la galerie fobizz et trouvez l'inspiration pour votre enseignement. Vous pouvez enregistrer le matériel en cliquant sur le <i class='bi bi-heart'></i>.",
        "title": "Votre liste de favoris est encore vide"
      },
      "links": {
        "toMaterial": "Découvrir du matériel pédagogique"
      },
      "title": "Matériel pédagogique enregistré"
    }
  }
}
